import { createSelector } from '@ngrx/store';
import { CustomAssetImage, CustomizableAssets } from '@shared/shared/interfaces/custom-assets.interfaces';
import * as fromFeature from '../reducers/';
import * as customAssetReducers from '../reducers/custom-assets.reducers';

export const getCustomAssetFeatureState = createSelector(
  fromFeature.getCustomAssetsState,
  (state: fromFeature.CustomAssetReducerState) => state.customAssets
);

export const getAllCustomAssets = createSelector(
  getCustomAssetFeatureState,
  (state: customAssetReducers.CustomAssetsState) => state
);

export const getSpecificCustomAsset = createSelector<
  object,
  { customAsset: keyof CustomizableAssets },
  customAssetReducers.CustomAssetsState,
  CustomAssetImage[]
>(
  getCustomAssetFeatureState,
  (state: customAssetReducers.CustomAssetsState, props: { customAsset: keyof CustomizableAssets }) => {
    if (!state.loaded) {
      return null;
    }

    if (props?.customAsset) {
      const customAsset = state[props.customAsset];
      return Array.isArray(customAsset) ? customAsset : [customAsset];
    }

    return [];
  }
);
